
import React, { createContext, useContext, useState, useEffect } from 'react';

const DatabaseContext = createContext();

export const DatabaseProvider = ({ children }) => {
  const [zelte, setZelte] = useState([]);

  useEffect(() => {
    fetch('/api/zelte') // Adjust the endpoint as needed
      .then(response => response.json())
      .then(data => setZelte(data))
      .catch(error => console.error('Error fetching zelte:', error));
  }, []);

  return (
    <DatabaseContext.Provider value={{ zelte }}>
      {children}
    </DatabaseContext.Provider>
  );
};

export const useDatabase = () => useContext(DatabaseContext);